import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your Firebase configuration
const firebaseConfig = {

 
  databaseURL: "https://digisavvy-32a41-default-rtdb.firebaseio.com",


  apiKey: "AIzaSyB7ZbnpT8Sk-3P9rdNYF5ALSAjTDZysYYU",
  authDomain: "digisavvy-32a41.firebaseapp.com",
  projectId: "digisavvy-32a41",
  storageBucket: "digisavvy-32a41.firebasestorage.app",
  messagingSenderId: "184679857686",
  appId: "1:184679857686:web:ad371b7c83a4fed0c87f37"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);
export const textdb = getFirestore(app);
export const storage = getStorage(app); 
export default app;
